import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Screen from '../../components/common/Screen';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Icon from '../../components/common/Icon';
import { apiRequest } from '../../utils';
import './MemberHome.css';

/* One specialist's PUBLIC profile — headline, services, member discount, bio and socials, built
   from the specialist profile fields. Shareable (no login), like the public host screen. Reached
   from the Specialists directory or a direct link. Backend: GET /api/public-specialist/:id (no auth). */
const SpecialistProfile = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    apiRequest('GET', `/public-specialist/${id}`)
      .then((res) => { if (!cancelled) setP(res); })
      .catch(() => { if (!cancelled) setMissing(true); });
    return () => { cancelled = true; };
  }, [id]);

  const socials = p ? [
    p.linkedin && { k: 'linkedin', name: 'linkedin', pack: 'brands', url: p.linkedin },
    p.instagram && { k: 'instagram', name: 'instagram', pack: 'brands', url: p.instagram },
    p.facebook && { k: 'facebook', name: 'facebook', pack: 'brands', url: p.facebook },
    p.twitter && { k: 'twitter', name: 'twitter', pack: 'brands', url: p.twitter },
    p.website && { k: 'website', name: 'globe', pack: 'br', url: p.website },
  ].filter(Boolean) : [];

  return (
    <Screen>
      <div className="top">
        <Card>
          <button type="button" className="bravos-wallet__link bravos-members__back"
                  onClick={() => navigate(-1)}>
            <Icon name="angle-left" /> {t('back')}
          </button>
        </Card>

        {missing ? (
          <Card><p className="text-muted mb-0">{t('specialistNotFound')}</p></Card>
        ) : p === null ? (
          <Card><span className="auth__spinner" /></Card>
        ) : (
          <Card className="bravos-profile-card">
            <div className="bravos-spec bravos-spec--full">
              {p.photo_url
                ? <img className="bravos-spec__photo" src={p.photo_url} alt="" />
                : <span className="bravos-spec__photo bravos-spec__photo--ph">
                    {(p.name || '?').slice(0, 1)}
                  </span>}
              <div className="bravos-spec__body">
                <Title my="0" align="left" className="mt-1">{p.name}</Title>
                {p.headline && <div className="bravos-spec__headline">{p.headline}</div>}
                {(p.roles || []).length > 0 && (
                  <div className="bravos-brand__roles">
                    {p.roles.map((r) => (
                      <span key={r.name} className="bravos-role-chip"
                            style={r.color ? { borderColor: r.color, color: r.color } : {}}>
                        {r.name}
                      </span>
                    ))}
                  </div>
                )}
                {socials.length > 0 && (
                  <div className="bravos-social">
                    {socials.map((s) => (
                      <a key={s.k} className="bravos-social__link" href={s.url}
                         target="_blank" rel="noreferrer" aria-label={s.k}>
                        <Icon name={s.name} pack={s.pack} />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {p.public_bio && (
              <p className="bravos-fb-block__text mt-3" style={{ whiteSpace: 'pre-line' }}>
                {p.public_bio}
              </p>
            )}

            {p.discount_note && (
              <p className="bravos-spec__discount mt-2">
                <Icon name="ticket" className="me-1" />{p.discount_note}
              </p>
            )}

            {(p.services || []).length > 0 && (
              <>
                <p className="bravos-cal__label">{t('servicesOffered')}</p>
                <ul className="bravos-spec__services">
                  {p.services.map((s, i) => <li key={i}>{s}</li>)}
                </ul>
              </>
            )}
          </Card>
        )}
      </div>
    </Screen>
  );
};

export default SpecialistProfile;
